<div class="flex flex-wrap gap-4">
    <mat-card class="w-full">
        <mat-card-content class="!flex items-center gap-4">
            <mat-form-field class="grow" subscriptSizing="dynamic">
                <input
                    matInput
                    [value]="searchText()"
                    (input)="searchTextChanged($event)"
                    placeholder="{{ 'General.Search' | transloco }}..." />
            </mat-form-field>
            @if (canShowFilter()) {
                <div class="ml-auto flex">
                    @if (savedFilters().length > 0) {
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="savedFilterSelection"
                            [matTooltip]="'Components.SearchFilter.SavedFilters' | transloco">
                            <mat-icon>topic</mat-icon>
                        </button>
                    }
                    <button
                        class="ml-auto"
                        mat-icon-button
                        (click)="toggleShowFilterAndSearch()"
                        [matTooltip]="'Components.SearchFilter.Filter' | transloco">
                        <mat-icon
                            [matBadge]="filterCount()"
                            matBadgeSize="small"
                            [matBadgeHidden]="filterCount() === 0"
                            aria-hidden="false">
                            filter_alt
                        </mat-icon>
                    </button>
                </div>
            }
        </mat-card-content>
    </mat-card>
    <mat-card class="w-full" [ngClass]="{ '!hidden': !showFilter() || !canShowFilter() }">
        <arc-filter [store]="store()" #filter />
    </mat-card>
</div>

<mat-menu #savedFilterSelection="matMenu">
    @for (savedFilter of savedFilters(); track savedFilter.name) {
        <div mat-menu-item (click)="applySavedFilter(savedFilter.id!)">
            <div class="flex items-center justify-between gap-8">
                <span [class.font-bold]="savedFilter.isDefault">
                    {{ savedFilter.isDefault ? ('Components.SearchFilter.DefaultFilter' | transloco) : savedFilter.name }}
                </span>
                <button
                    [disabled]="isDeleting()"
                    mat-icon-button
                    (click)="deleteSavedFilter(savedFilter.id!, $event)"
                    [matTooltip]="'Components.SearchFilter.DeleteSavedFilter' | transloco">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
    }
</mat-menu>
